import { doDelete, doGet, doPost, doPut } from '@app/api';
import { API_RESPONSE_STATUS_CODE } from '@app/constants/common';
import { NEW_FEEDBACK_SITE } from '@app/constants/feedback-site';
import { IFeedbackSite } from '@app/interfaces/feedback-site.interface';

export const getFeedbackSites = async () => {
  try {
    const result = await doGet('/api/feedback-site', {});

    if (result.status === API_RESPONSE_STATUS_CODE.SUCCESS) {
      return result.data;
    }
  } catch (e) {
    console.log('e', e);
  }
};

export const addFeedbackSite = async (newFeedbackSite: typeof NEW_FEEDBACK_SITE) => {
  try {
    const result = await doPost('/api/feedback-site', {
      feedbackSite: newFeedbackSite,
    });

    if (result.status === API_RESPONSE_STATUS_CODE.CREATED) {
      return result.data;
    }
  } catch (e) {
    console.log('e', e);
  }
};

export const updateFeedbackSite = async (feedbackSite: IFeedbackSite) => {
  try {
    const result = await doPut(`/api/feedback-site/${feedbackSite.id}`, {
      feedbackSite,
    });

    if (result.status === API_RESPONSE_STATUS_CODE.SUCCESS) {
      return result.data;
    }
  } catch (e) {
    console.log('e', e);
  }
};

export const deleteFeedbackSite = async (feedbackSite: IFeedbackSite) => {
  try {
    await doDelete(`/api/feedback-site/${feedbackSite.id}`, {});
  } catch (e) {
    console.log('e', e);
  }
};
